import { HamburgerIcon, LockIcon } from '@chakra-ui/icons'
import {
  Box,
  Grid,
  GridItem,
  IconButton,
  Menu,
  MenuButton,
  MenuItem,
  MenuList
} from '@chakra-ui/react'
import React from 'react'
import { FaUserAlt } from "react-icons/fa"
import { LiaStoreAltSolid } from "react-icons/lia"
import { LuClipboardList } from "react-icons/lu"
import { TbLogout } from "react-icons/tb"
import { Route, Routes, useNavigate } from 'react-router-dom'
import ProfileFooter from '../../../Components/Footer/ProfileFooter'
import AdminSidebar from '../../../Components/Sidebar/AdminSidebar'
import AdminProfile from './AdminProfile'
import ChangePassword from './ChangePassword'
import ListedProperties from './ListedProperties'
import SubmitProperty from './SubmitProperty'



const AdminDashboard = () => {
  const navigate = useNavigate();
  const handleLogoutClick = () => {
    sessionStorage.removeItem('token');
    window.location.reload();
  }
  return (
    <Box>
      <Box display='flex' alignItems='center' justifyContent='center' background='#FAFAFA' padding={{ base: '0 12px 35px', xl: '60px 12px 35px' }}>
        <Box maxWidth='1300px' minH="55vh" w={{ base: '100%', sm: '83%' }} marginTop='35px' paddingX='10px'>
          <Grid w='100%' templateColumns='repeat(12, 1fr)' gap={{ base: 2, xl: 10 }}>
            <GridItem colSpan={{ base: 0, xl: 3 }} display={{ base: 'none', xl: 'block' }}>
              <AdminSidebar />
            </GridItem>
            <GridItem w='100%' colSpan={{ base: 12, xl: 9 }}>
              <Box w='100%' display='block'>
                <Box mb="30px" display={{ base: 'block', xl: 'none' }}>
                  <Menu>
                    <MenuButton as={IconButton} icon={<HamburgerIcon />} />
                    <MenuList>
                      <MenuItem onClick={() => navigate('/admin-dashboard')} icon={<FaUserAlt />}>
                        Profile
                      </MenuItem>
                      <MenuItem onClick={() => navigate('/admin-dashboard/submit-a-property')} icon={<LiaStoreAltSolid />}>
                        Submit a Property
                      </MenuItem>
                      <MenuItem onClick={() => navigate('/admin-dashboard/listed-properties')} icon={<LuClipboardList />}>
                        Listed Properties
                      </MenuItem>
                      <MenuItem onClick={() => navigate('/admin-dashboard/change-password')} icon={<LockIcon />}>
                        Change Password
                      </MenuItem>
                      <MenuItem onClick={handleLogoutClick} icon={<TbLogout />}>
                        Logout
                      </MenuItem>
                    </MenuList>
                  </Menu>
                </Box>
                <Box w='100%' display='block'>
                  <Routes>
                    <Route path={'/'} element={<AdminProfile />} />
                    <Route path={'/submit-a-property'} element={<SubmitProperty />} />
                    <Route path={'/listed-properties'} element={<ListedProperties />} />
                    <Route path={'/change-password'} element={<ChangePassword />} />
                  </Routes>
                </Box>
              </Box>
            </GridItem>
          </Grid>
        </Box>
      </Box>
      <ProfileFooter />
    </Box>
  )
}

export default AdminDashboard